import React from 'react';

const FormError = (props) => {
  const { errorText } = props;
  return (
    <div className="form-error" >
      <i className="td-icon icon-information" />
      {errorText}
    </div>
  );
};

export default FormError;
